import Dashboard from "@/components/Dashboard";
import ServerListPage from "@/pages/ServerListPage";
import AltaBase from "@/pages/AltaBase";
import RestoreBackup from "@/pages/RestoreBackup";
import BackupsCleanUp from "@/pages/BackupsCleanUp";
import ClientsList from "@/pages/ClientsList";
import ResetPassword from "@/pages/ResetPassword"
import Uploads from "@/pages/Uploads"
import ChatBase from "./pages/ChatBase.vue";
// import Login from "@/components/Login"
import store from './store.js'

import VueRouter from "vue-router";

const routes = [
    { path: '/', component: Dashboard, meta: {
        requiresAuth: true
      }
    },
    { path: '/alta-base', component: AltaBase,  meta: {
        requiresAuth: true
      }
    },
    { path: '/restaurar-base', component: RestoreBackup,  meta: {
      requiresAuth: true
      }
    },
    { path: '/lista-servidores', component: ServerListPage, meta: {
      requiresAuth: true
      } 
    },
    { path: '/limpieza-backups', component: BackupsCleanUp, meta: {
      requiresAuth: true
      } 
    },
    { path: '/lista-clientes', component: ClientsList, meta: {
      requiresAuth: true
      } 
    },
    { path: '/reset-password', component: ResetPassword, meta: {
      requiresAuth: true
      } 
    },
    { path: '/uploads', component: Uploads, meta: {
      requiresAuth: true
    } },
    { path: '/chat', component: ChatBase, meta: {
      requiresAuth: true
    } },
]

const router = new VueRouter
({
    mode: 'hash',
    routes
})

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
        next()
        return
      }
      next('/login')
    } else {
      next()
    }
  })


export default router;